module.exports = __webpack_public_path__ + "img/soy.69ea0a2f.svg";